var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWidgetsClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11518_19415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 15.8333L4.16675 14.6666L8.83342 9.99996L4.16675 5.33329L5.33341 4.16663L10.0001 8.83329L14.6667 4.16663L15.8334 5.33329L11.1667 9.99996L15.8334 14.6666L14.6667 15.8333L10.0001 11.1666L5.33341 15.8333Z",
    fill: "#95A1C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11518_19415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetsClose);
export default __webpack_public_path__ + "static/media/widgets_close.b05f3307d64704778eeb6540dd368bd8.svg";
export { ForwardRef as ReactComponent };